// для удаления цикличных данных (АККУРАТНО)
export const JSOGDeleteCircular = (obj, weak = new WeakSet()) => {
  const newObj = {};
  if (typeof obj === 'object') {
    if (!obj) return obj; // если объект null или undefined
    if (weak.has(obj)) { // если объект уже существовал
      return null; // то вместо него ставим null
    }
    weak.add(obj); // если объекта не было, то добавляем его в сет
    if (Array.isArray(obj)) { // если это массив, то пробегаемся по всем элементам массива выполняя удаление цикличных данных
      const tmp = obj.map((item) => JSOGDeleteCircular(item, weak));
      weak.delete(obj);
      if (tmp.length === 1 && tmp[0] === null) return null;
      return tmp;
    }
    Object.keys(obj).forEach((key) => {
      newObj[key] = JSOGDeleteCircular(obj[key], weak);
    });
      weak.delete(obj);
    return newObj;
  }
  return obj;
};
